import { buildTranscript } from "@intelligems/ig-plugin/builder/workflows/processors/utils";
import { copyToClipboard } from "@src/utils/copyToClipboard";

import { useExecutionPanelContext } from "../ExecutionPanelContext";
import { ExecutionPanelMenuItem } from "./ExecutionPanelMenuItem";

/**
 * The chat menu's built-in entries, one prop-less component each: they read the
 * panel context directly, so a surface overriding the `menuItems` slot can drop
 * in the ones it wants and leave out the rest.
 */
export const NewChatMenuItem = () => {
  const { onNewChat } = useExecutionPanelContext();

  // Self-gating: surfaces without a new-chat action just don't render it.
  if (!onNewChat) {
    return null;
  }

  return (
    <ExecutionPanelMenuItem onClick={onNewChat}>
      New Chat
    </ExecutionPanelMenuItem>
  );
};

export const CopyChatIdMenuItem = () => {
  const { aiChat, copyIdOverride } = useExecutionPanelContext();
  const id = copyIdOverride?.id ?? aiChat.sessionId;

  return (
    <ExecutionPanelMenuItem
      disabled={!id}
      onClick={() => void copyToClipboard(id ?? "")}
    >
      {copyIdOverride?.label ?? "Copy Chat ID"}
    </ExecutionPanelMenuItem>
  );
};

export const CopyTranscriptMenuItem = () => {
  const { aiChat } = useExecutionPanelContext();

  return (
    <ExecutionPanelMenuItem
      disabled={aiChat.turns.length === 0}
      onClick={() => void copyToClipboard(buildTranscript(aiChat))}
    >
      Copy Transcript
    </ExecutionPanelMenuItem>
  );
};

/**
 * Default contents of the `menuItems` slot. A surface overriding that slot can
 * render this to keep every built-in, or compose the items above individually.
 */
export const ExecutionPanelMenuItems = () => (
  <>
    <NewChatMenuItem />
    <CopyChatIdMenuItem />
    <CopyTranscriptMenuItem />
  </>
);
